export const SERVICE = 'API.aspx/GetCategoryList';
export const INTRODUCE = 'API.aspx/GetContent';
export const NEWS = 'API.aspx/GetNewsList';
export const NEWS_DETAIL = 'API.aspx/GetNewsItem';
